import { IDmChienDich, IDmChienDichVm } from "../../../models/response/crm-survey/IDmChienDich";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objChienDichDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as IDmChienDichVm[],
    LOAD_ERROR: "",
    LOAD_COSO_START: 0,
    LOAD_COSO_SUCCESS: [] as IDmChienDichVm[],
    LOAD_COSO_ERROR: "",
    LOAD_TRUONG_START: 0,
    LOAD_TRUONG_SUCCESS: [] as IDmChienDich[],
    LOAD_TRUONG_ERROR: "",
    SHOW_EDIT_MODAL: {} as IDmChienDich | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IDmChienDich,
    SAVE_SUCESS: {} as IDmChienDich,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: "",
    LOCK_START: 0,
    LOCK_SUCESS: undefined,
    LOCK_ERROR: "",
    UNLOCK_START: 0,
    UNLOCK_SUCESS: undefined,
    UNLOCK_ERROR: "",
};
export const eChienDichActionTypeIds = generateActionTypeIds(objChienDichDefine, "CHIEN_DICH")
export type IChienDichActionTypes = IGenericActionType<typeof objChienDichDefine, "CHIEN_DICH">
